import React, { useEffect } from "react";
import './UpBtn.css';
import $ from "jquery";



export default function UpBtn() {

  useEffect(() => {
    $('#backToTopBtn').click(function() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    });
  }, []);

  // Start Btn To Up
window.onscroll = function () {
  scrollFunction();
};
function scrollFunction() {
  if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
    document.getElementById("backToTopBtn").style.display = "block";
  } else {
    document.getElementById("backToTopBtn").style.display = "none";
  }
}
//  End To Up


  return (
    <>
      <button id="backToTopBtn">
        <i class="fa-solid fa-up-long"></i>
      </button>
    </>
  );
}
